/* RESPONSIBLE TEAM: team-standalone */
import { ReactRoute } from 'embercom/lib/react-route';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

class PlatformSettingsRoute extends Route {
  @service declare router: Router;
  @service declare finStandaloneService: FinStandaloneService;

  reactEnabled() {
    return true;
  }

  beforeModel() {
    if (!this.finStandaloneService.canAccessPlatformMessengerSettingsTab) {
      this.router.replaceWith('apps.app.settings.channels.messenger.web');
    }
  }

  buildRouteInfoMetadata() {
    return { responsibleTeam: 'team-standalone', react: true };
  }
}

export default ReactRoute(PlatformSettingsRoute);
